import React from "react";

const KeyThin = ({ className }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${className}`}
  >
    <path d="M10.3335 4.99992L12.6668 2.66659M14.0002 1.33325L12.6668 2.66659L14.0002 1.33325ZM7.59352 7.73992C7.93774 8.07956 8.21138 8.48394 8.39869 8.92978C8.58599 9.37561 8.68325 9.8541 8.68487 10.3377C8.68649 10.8213 8.59243 11.3004 8.40812 11.7475C8.22381 12.1945 7.95289 12.6007 7.61095 12.9427C7.269 13.2846 6.8628 13.5556 6.41572 13.7399C5.96864 13.9242 5.48952 14.0182 5.00594 14.0166C4.52236 14.015 4.04388 13.9177 3.59804 13.7304C3.15221 13.5431 2.74783 13.2695 2.40818 12.9253C1.74027 12.2337 1.37069 11.3075 1.37904 10.3461C1.3874 9.38473 1.77302 8.46508 2.45285 7.78525C3.13268 7.10542 4.05232 6.7198 5.01371 6.71145C5.9751 6.70309 6.90131 7.07267 7.59285 7.74059L7.59352 7.73992ZM7.59352 7.73992L10.3335 4.99992L7.59352 7.73992ZM10.3335 4.99992L12.3335 6.99992L14.6668 4.66659L12.6668 2.66659L10.3335 4.99992Z" />
  </svg>
);

export default KeyThin;
